import { reactive } from 'vue';
import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { HeaderService } from '@telecom/shared/services/header-service/header-service';
import { HeaderService as HeaderServiceImpl } from '@patsnap-utils/biz';
import { HeaderServiceProxy } from '@telecom/shared/services/header-service/header-service-proxy';
import { HeaderServiceProxyImpl } from '@/services/header-service/impls/header-service-proxy';

export const headerServiceModule = new ContainerModule((bind) => {
    bind(HeaderService).toConstantValue(reactive(new HeaderServiceImpl()));
    bind(HeaderServiceProxy).to(HeaderServiceProxyImpl);
});
